/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function YouTubers() {
  return (
    <>
      <div className="section section-dark text-center gradient-background-claro">
        <Container>
          <h2 className="title gradient-title"> YouTube Chanels </h2>
          <hr style={{ clear: 'both' }} />
          <Row>

            <Col md="4">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.youtube.com/c/RuiVoPlay" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Ruivo.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.youtube.com/c/RuiVoPlay" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> Ruivo </CardTitle>
                      <h6 className="card-category"> Retro games and consoles </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    Making the first video for the Brazilian public, as well as updating them with the latest updates on the game.
                  </p>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-just-icon btn-neutral"
                    color="link"
                    href="https://www.youtube.com/c/RuiVoPlay"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-youtube-play" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.facebook.com/RuivoGameplays"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-facebook" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.instagram.com/ruivoplay/"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-instagram" />
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="4">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.youtube.com/user/RussianONIZUKA" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/RLP.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.youtube.com/user/RussianONIZUKA" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> Russian Let's Play </CardTitle>
                      <h6 className="card-category"> Games </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    Making the first video for the Russian public, as well as updating them with the latest updates on the game.
                    </p>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-just-icon btn-neutral"
                    color="link"
                    href="https://www.youtube.com/user/RussianONIZUKA"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-youtube-play" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://twitter.com/Russian_ONIZUKA"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-twitter" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.facebook.com/igrofilmy"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-facebook" />
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="4">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.youtube.com/c/MKAddict" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/MKA.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.youtube.com/c/MKAddict" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> MKA </CardTitle>
                      <h6 className="card-category"> MK Streamer | Mugen Developer </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    Making the first video of the game on YouTube!! as well as updating them with the latest updates on the game.
                    </p>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-just-icon btn-neutral"
                    color="link"
                    href="https://www.youtube.com/c/MKAddict"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-youtube-play" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://twitter.com/MKAddictYT"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-twitter" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.facebook.com/MortalKombatAddict/"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-facebook" />
                  </Button>
                </CardFooter>
              </Card>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}

export default YouTubers;
